/* src/app/modules/agent/pages/tele-calling-user-list/tele-calling-user-list.page.scss */
.tele-icon-btn-delete {
  background: var(--ion-color-secondary-shade);
  color: #fff;
}
.page-responsive {
  min-height: 100%;
  padding: 0 0 32px;
}
.tele-calling-page {
  padding: 0;
}
.tele-header {
  --background: var(--ion-color-secondary);
  border-bottom: 1px solid var(--ion-color-secondary-contrast);
  box-shadow: 0 2px 12px var(--ion-color-secondary-contrast);
}
.tele-page-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0px 10px 5px;
}
.tele-header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}
.tele-header-icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-secondary-contrast);
  flex-shrink: 0;
}
.tele-header-icon-box ion-icon {
  font-size: 22px;
  color: var(--ion-color-secondary-shade);
}
.tele-header-kicker {
  display: block;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 1px;
  color: var(--ion-color-primary);
}
.tele-header-title {
  margin: 2px 0 0;
  color: var(--ion-color-secondary-shade);
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
}
.tele-toggle-wrap {
  width: 100%;
  padding-bottom: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tele-tab-strip {
  gap: 4px;
  padding: 4px;
  background: white;
  border-radius: 14px;
  width: 100%;
  color: var(--ion-color-secondary-shade);
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 500px;
}
.tele-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 6px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--ion-color-secondary-shade);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.2px;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;
  min-width: 100px !important;
}
.tele-tab ion-icon {
  font-size: 18px;
  transition: transform 0.2s ease;
}
.tele-tab:hover:not(.tele-tab--active) {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.85);
}
.tele-tab.tele-tab--active {
  background: var(--ion-color-primary);
  color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
}
.tele-tab.tele-tab--active ion-icon {
  transform: scale(1.12);
}
.tele-section {
  padding: 0px 12px 0;
  display: grid;
  gap: 12px;
}
.section-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.section-title-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
.section-icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-secondary-contrast);
  flex-shrink: 0;
}
.section-icon-box ion-icon {
  font-size: 20px;
  color: var(--ion-color-secondary-shade);
}
.section-kicker {
  display: block;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 1px;
  color: var(--ion-color-primary);
}
.section-title {
  margin: 2px 0 0;
  color: var(--ion-color-secondary-shade);
  font-size: 16px;
  font-weight: 500;
  line-height: 1.25;
}
.section-actions-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.surface-card {
  border-radius: 22px;
  border: 1px solid var(--ion-color-secondary-contrast);
  box-shadow: 0 14px 26px var(--ion-color-secondary-contrast);
  background: var(--ion-color-secondary);
  margin: 0 !important;
}
.surface-card ion-card-content {
  padding: 14px 10px;
}
.shell-card ion-card-content {
  background:
    linear-gradient(
      180deg,
      var(--ion-color-secondary) 0%,
      var(--ion-color-primary-tint) 100%);
}
.shell-card {
  width: 100%;
}
.info-card {
  margin: 0 !important;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid var(--ion-color-secondary-contrast);
  background: white;
  box-shadow: 0 6px 14px var(--ion-color-secondary-contrast);
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition:
    transform 0.18s ease,
    border-color 0.18s ease,
    box-shadow 0.18s ease;
}
.info-card:hover,
.info-card:focus-within {
  transform: translateY(-2px);
  border-color: var(--ion-color-primary);
  box-shadow: 0 10px 20px var(--ion-color-secondary-contrast);
}
.employee-grid ion-col,
.employee-grid {
  padding: 6px;
}
.info-card--selected {
  border-color: var(--ion-color-primary) !important;
  background:
    linear-gradient(
      155deg,
      var(--ion-color-primary-tint) 0%,
      #fff8f7 100%) !important;
}
.info-card-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.info-card-identity {
  display: flex;
  align-items: center;
  gap: 12px;
}
.info-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-secondary-contrast);
  flex-shrink: 0;
}
.info-avatar ion-icon {
  font-size: 26px;
  color: var(--ion-color-secondary-shade);
}
.tele-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-secondary-contrast);
  flex-shrink: 0;
}
.tele-icon-wrap ion-icon {
  font-size: 22px;
  color: var(--ion-color-secondary-shade);
}
.info-name-block {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.info-primary-text {
  font-size: 14px;
  font-weight: 500;
  color: var(--ion-color-secondary-shade);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info-secondary-text {
  font-size: 12px;
  color: var(--ion-color-primary-contrast);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info-detail-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
}
.info-detail-cell {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.info-detail-cell--full {
  grid-column: 1/-1;
}
.detail-label {
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.4px;
  color: var(--ion-color-primary-contrast);
}
.detail-value {
  font-size: 12px;
  font-weight: 500;
  color: var(--ion-color-secondary-shade);
  word-break: break-word;
}
.role-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.4px;
}
.role-badge--admin {
  background: var(--ion-color-primary);
  color: #fff;
}
.role-badge--lead {
  background: var(--ion-color-dark);
  color: #fff;
}
.role-badge--manager {
  background: var(--ion-color-secondary-shade);
  color: #fff;
}
.role-badge--employee {
  background: var(--ion-color-light-tint);
  color: #fff;
}
.tele-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid var(--ion-color-light-tint);
  background: var(--ion-color-secondary);
  color: var(--ion-color-primary);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.4px;
}
.tele-chip--done {
  background: var(--ion-color-primary-tint);
  color: var(--ion-color-secondary-shade);
  border-color: var(--ion-color-secondary-contrast);
}
.chip-scroll-container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 8px;
  padding: 10px 0 6px;
  scrollbar-width: none;
}
.chip-scroll-container::-webkit-scrollbar {
  display: none;
}
.tele-filter-chip {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 999px;
  border: 1px solid var(--ion-color-secondary-shade);
  background: var(--ion-color-secondary);
  color: var(--ion-color-secondary-shade);
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease;
}
.tele-filter-chip:hover {
  background: var(--ion-color-primary-tint);
}
.bulk-action-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 4px;
  border-bottom: 1px solid var(--ion-color-secondary-contrast);
  margin-bottom: 10px;
}
.bulk-action-left,
.bulk-action-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.select-all-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0px 4px 10px;
  border-bottom: 1px solid var(--ion-color-secondary-contrast);
  margin-bottom: 8px;
}
.select-label {
  font-size: 13px;
  color: var(--ion-color-secondary-shade);
}
.selection-chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  background: var(--ion-color-primary);
  color: #fff;
  font-size: 11px;
  font-weight: 500;
}
.contact-stats-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.stat-pill {
  flex: 1;
  min-width: 56px;
  padding: 7px 4px;
  border-radius: 20px;
  background: var(--ion-color-primary-tint);
  border: none;
  font-size: 13px;
  font-weight: 500;
  color: var(--ion-color-secondary-shade);
  letter-spacing: normal;
  cursor: pointer;
  transition: background 0.15s ease;
}
.stat-pill:hover {
  background: var(--ion-color-secondary-contrast);
}
.info-card-footer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--ion-color-secondary-contrast);
  flex-wrap: wrap;
}
.tele-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
  text-decoration: none;
  flex-shrink: 0;
}
.tele-icon-btn ion-icon {
  font-size: 18px;
}
.tele-icon-btn:hover {
  opacity: 0.85;
  transform: scale(1.08);
}
.tele-icon-btn--whatsapp {
  background: #25D366;
  color: #fff;
}
.tele-icon-btn--call {
  background: var(--ion-color-dark);
  color: #fff;
}
.tele-icon-btn--delete {
  background: var(--ion-color-danger);
  color: #fff;
}
.tele-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: normal;
  cursor: pointer;
  border: none;
  transition: opacity 0.15s ease;
}
.tele-action-btn ion-icon {
  font-size: 14px;
}
.tele-action-btn:hover {
  opacity: 0.85;
}
.tele-action-btn--primary {
  background: var(--ion-color-secondary-shade);
  color: #fff;
  margin-left: auto;
}
.tele-action-btn--outline {
  background: transparent;
  color: var(--ion-color-secondary-shade);
  border: 1px solid var(--ion-color-secondary-shade);
}
.tele-action-btn--danger {
  background: var(--ion-color-danger);
  color: #fff;
}
.tele-menu-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
}
.tele-menu-btn:hover {
  background: var(--ion-color-primary-tint);
}
.tele-export-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 10px;
  background: var(--ion-color-secondary-shade);
  color: #fff;
  border: none;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: normal;
  cursor: pointer;
  transition: opacity 0.15s ease;
}
.tele-export-btn ion-icon {
  font-size: 15px;
}
.tele-export-btn:hover {
  opacity: 0.87;
}
.tele-search-bar {
  --border-radius: 30px;
  --box-shadow: none;
  padding: 0 !important;
  flex: 1;
  min-width: 0;
}
.tele-search-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 4px;
}
.tele-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  color: #fff;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.15s ease;
}
.tele-search-btn ion-icon {
  font-size: 18px;
}
.tele-search-btn:hover {
  opacity: 0.85;
}
.tele-search-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.done-search-row {
  padding: 8px 0 4px;
}
.emp-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.emp-search-wrap {
  width: 100%;
}
.emp-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--ion-color-primary-tint);
  border: 2px solid var(--ion-color-secondary-shade);
  flex-shrink: 0;
  box-shadow: 0 4px 10px var(--ion-color-secondary-contrast);
}
.emp-avatar ion-icon {
  font-size: 28px;
  color: #fff;
}
.emp-mobile-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-secondary-contrast);
}
.emp-mobile-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--ion-color-secondary);
  border: 1px solid var(--ion-color-secondary-contrast);
  flex-shrink: 0;
}
.emp-mobile-icon ion-icon {
  font-size: 14px;
  color: var(--ion-color-secondary-shade);
}
.tele-action-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: var(--ion-color-secondary);
  border: 1px solid var(--ion-color-secondary-contrast);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.tele-action-icon-wrap ion-icon {
  font-size: 18px;
  color: var(--ion-color-secondary-shade);
}
.tele-action-icon-wrap:hover {
  background: var(--ion-color-primary-tint);
  border-color: var(--ion-color-primary);
}
.lead-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
}
.lead-header-copy {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.lead-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
}
.lead-detail-cell {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.lead-detail-cell--full {
  grid-column: 1/-1;
}
ion-card-header {
  padding: 0;
}
ion-badge {
  background: var(--ion-color-secondary-shade);
  color: #fff;
  font-size: 10px;
  font-weight: normal;
}
mat-selection-list {
  width: 100%;
}
.contact-stat-strip {
  display: flex;
  align-items: stretch;
  background: var(--ion-color-secondary);
  border: 1px solid var(--ion-color-secondary-contrast);
  border-radius: 18px;
  padding: 12px 6px;
  box-shadow: 0 4px 12px var(--ion-color-secondary-contrast);
  overflow-x: auto;
  scrollbar-width: none;
}
.contact-stat-strip::-webkit-scrollbar {
  display: none;
}
.contact-stat-item {
  flex: 1;
  min-width: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 4px 8px;
}
.contact-stat-value {
  font-size: 20px;
  font-weight: 500;
  color: var(--ion-color-secondary-shade);
  line-height: 1;
}
.contact-stat-value--warn {
  color: var(--ion-color-warning-shade, #e0b500);
}
.contact-stat-value--success {
  color: #10b981;
}
.contact-stat-value--info {
  color: var(--ion-color-dark);
}
.contact-stat-value--muted {
  color: var(--ion-color-primary-contrast);
}
.contact-stat-label {
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.4px;
  color: var(--ion-color-primary-contrast);
  text-align: center;
  white-space: nowrap;
}
.contact-stat-divider {
  width: 1px;
  align-self: stretch;
  background: var(--ion-color-secondary-contrast);
  margin: 4px 0;
}
.tab-shell-card ion-card-content {
  padding: 8px 8px 12px;
}
.contact-tab-group .mat-mdc-tab-header {
  border-bottom: 2px solid var(--ion-color-secondary-contrast);
  margin-bottom: 4px;
}
.contact-tab-group .mat-mdc-tab {
  min-width: 0;
  padding: 0 6px;
  opacity: 1 !important;
}
.contact-tab-group .mat-mdc-tab:not(.mdc-tab--active) .tab-label-wrap {
  opacity: 0.65;
}
.contact-tab-group .mdc-tab-indicator__content--underline {
  border-color: var(--ion-color-primary) !important;
  border-top-width: 3px !important;
  border-radius: 3px 3px 0 0;
}
.tab-label-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  padding: 4px 2px;
}
.tab-label-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 8px;
}
.tab-label-icon ion-icon {
  font-size: 14px;
}
.tab-label-icon--pending {
  background: #fff3cd;
  color: #b45309;
}
.tab-label-icon--done {
  background: #d1fae5;
  color: #065f46;
}
.tab-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 500;
}
.tab-count-badge--pending {
  background: #fef3c7;
  color: #92400e;
}
.tab-count-badge--done {
  background: #d1fae5;
  color: #065f46;
}
.tab-bulk-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 6px 0 0px;
  border-radius: 12px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-secondary-contrast);
}
.tab-bulk-left,
.tab-bulk-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tab-bulk-label {
  font-size: 13px;
  color: var(--ion-color-secondary-shade);
}
.contact-card {
  position: relative;
  padding-left: 18px !important;
}
.contact-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  border-radius: 18px 0 0 18px;
}
.contact-card--pending::before {
  background: var(--ion-color-secondary-shade);
}
.contact-card--done::before {
  background:
    linear-gradient(
      180deg,
      #10b981,
      #34d399);
}
.contact-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.4px;
}
.contact-status-badge ion-icon {
  font-size: 12px;
}
.contact-status-badge--pending {
  background: #fef3c7;
  color: #92400e;
}
.contact-status-badge--done {
  background: #d1fae5;
  color: #065f46;
}
.contact-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: var(--ion-color-primary-tint);
  border: 2px solid var(--ion-color-secondary-shade);
  flex-shrink: 0;
}
.contact-avatar ion-icon {
  font-size: 24px;
  color: var(--ion-color-secondary-shade);
}
.contact-avatar--done {
  border-color: #34d399;
}
.contact-mobile-row {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 3px;
}
.contact-mobile-row ion-icon {
  font-size: 15px;
  color: var(--ion-color-secondary-shade);
  flex-shrink: 0;
}
.contact-take-action {
  margin-left: auto;
}
.contact-response-block {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-secondary-contrast);
}
.contact-response-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.contact-response-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.response-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  background: #d1fae5;
  color: #065f46;
  font-size: 11px;
  font-weight: 500;
  width: fit-content;
}
.contact-response-comment,
.contact-response-date {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}
.contact-response-comment ion-icon,
.contact-response-date ion-icon {
  font-size: 13px;
  color: var(--ion-color-primary-contrast);
  flex-shrink: 0;
  margin-top: 2px;
}
/*# sourceMappingURL=tele-calling-user-list.page.css.map */
